import axios from 'axios';
import authHeader from '@/services/auth-header';
export default {
    getInformationType({ commit }) {
        axios
            .get("/info-type", { headers: authHeader() })
            .then(response => (commit('setAll', response.data)));
    }
};